var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainHubPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#513764;}\n\t.st1{fill:#333132;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#2CC2E0;}\n\t.st4{fill:#F7941D;}\n\t.st5{fill:#8DC63F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2180",
    className: "st0",
    d: "M30-0.1h40c16.6,0,30,13.4,30,30v70l0,0H30c-16.6,0-30-13.4-30-30v-40 C0,13.4,13.4-0.1,30-0.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    className: "st1",
    d: "M40,79.9c22.1,0,40-17.9,40-40S62-0.1,40-0.1S0,17.8,0,39.9S17.9,79.9,40,79.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    className: "st2",
    d: "M40,68.1c15.6,0,28.2-12.6,28.2-28.2c0-15.6-12.6-28.2-28.2-28.2c-15.6,0-28.2,12.6-28.2,28.2 C11.8,55.5,24.4,68.1,40,68.1L40,68.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3568",
    className: "st3",
    d: "M40,70.6c-17,0-30.7-13.7-30.7-30.7S23,9.2,39.9,9.2S70.6,23,70.7,39.9c0,0,0,0,0,0 C70.6,56.9,56.9,70.6,40,70.6 M40,14.2c-14.2,0-25.7,11.5-25.7,25.7S25.8,65.6,40,65.6s25.7-11.5,25.7-25.7 C65.6,25.8,54.1,14.3,40,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    className: "st4",
    d: "M46.7,41.7H50c0.6,0,1.1,0.5,1.1,1.1v3.3c0,0.6-0.5,1.1-1.1,1.1h-3.3c-0.6,0-1.1-0.5-1.1-1.1 v-3.3C45.6,42.2,46.1,41.7,46.7,41.7 M33.2,47.2h-3.3c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0v-3.3c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0 h3.3c0.6,0,1.1,0.5,1.1,1.1v3.3C34.3,46.7,33.8,47.2,33.2,47.2 M26,40.4v11.3c0,0.9,0.7,1.6,1.6,1.6h7.9c0.9,0,1.6-0.7,1.6-1.6 v-8.3c0-0.9,0.7-1.6,1.6-1.6c0,0,0,0,0,0h2.2c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0v8.3c0,0.9,0.7,1.6,1.6,1.6c0,0,0,0,0,0h7.9 c0.9,0,1.6-0.7,1.6-1.6V40.4c0-0.5-0.2-0.9-0.5-1.2L41.1,27.9c-0.6-0.6-1.6-0.6-2.2,0L26.6,39.2C26.2,39.5,26,40,26,40.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    className: "st4",
    d: "M51.1,32.3v-6.5c0-0.9-0.7-1.6-1.6-1.6h-0.6c-0.9,0-1.6,0.7-1.6,1.6v3l-4.5-4.2 c-1.6-1.4-4-1.4-5.5,0L21.6,39c-0.4,0.4-0.4,0.9,0,1.3c0.3,0.4,0.9,0.4,1.3,0.1l15.4-14.1c1-0.9,2.5-0.9,3.5,0L57,40.3 c0.4,0.3,1,0.3,1.3-0.1c0.3-0.4,0.3-1-0.1-1.3L51.1,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    className: "st5",
    d: "M40,77.9c-21,0-38-17-38-38c0-10.1,4-19.7,11.1-26.9c1-1.1,2.8-1.2,3.9-0.1s1.2,2.8,0.1,3.9 c0,0-0.1,0.1-0.1,0.1C4.3,29.7,4.3,50.2,17,62.9s33.2,12.7,45.9,0s12.7-33.2,0-45.9C56.8,10.9,48.6,7.5,40,7.5 c-1.5,0-2.8-1.2-2.8-2.8C37.2,3.2,38.4,2,40,2c0,0,0,0,0,0c21,0,38,17,38,38S60.9,77.9,40,77.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainHubPurple);
export default __webpack_public_path__ + "static/media/Main_Hub_Purple.326b900ac60bb42245052ce35de12a65.svg";
export { ForwardRef as ReactComponent };